export const addLogo = () => {
    const jobTiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobTiles) {
        return;
    }

    jobTiles.forEach((jobTile) => {
        const altText = jobTile.querySelector(".attrax-vacancy-tile__option-marques .attrax-vacancy-tile__item-value")?.textContent?.trim() || ''

        let logoWrapper = document.createElement("div");
        logoWrapper.classList.add("attrax-vacancy-tile__logo-wrapper");
        const logoImage = document.createElement("img");

        Object.assign(logoImage, {
            loading: 'lazy',
            alt: altText,
            width: 50,
            height: 50,
            src: '/Blob/images/logos/covea.svg'
        });
        logoImage.classList.add("attrax-vacancy-tile__logo-image");
        logoWrapper.appendChild(logoImage);
        jobTile.prepend(logoWrapper);
    });
};

export const logoReplacer = () => {
    const jobOptionClass: string = ".attrax-vacancy-tile--";

    //the options given should be the same name give to logos placed in the logo folder including the file extension
    const optionArray: Array<string> = ["covea", "fidelia", "gmf", "maaf", "mma"];

    optionArray.forEach((option) => {
        const className = jobOptionClass + option;

        if (document.getElementsByClassName(className)) {
            const filePath = `/Blob/images/logos/${option}.svg`;

            const foundClass: Element[] = Array.from(
                document.querySelectorAll(className)
            );

            foundClass.forEach((option) => {
                const parentTile: HTMLElement | null = option.closest(
                    ".attrax-vacancy-tile"
                );

                if (!parentTile) return;

                const logowrapper: HTMLElement | null = parentTile.querySelector(
                    ".attrax-vacancy-tile__logo-wrapper"
                );
                const logoimage: HTMLImageElement | null = parentTile.querySelector(
                    ".attrax-vacancy-tile__logo-image"
                );

                if (!logowrapper || !logoimage) return;

                logoimage.src = filePath;
            });
        }
    });
};

export const brandClassAssignment = () => {
    const brandtiles = document.querySelectorAll(
        ".attrax-vacancy-tile__option-brand"
    );

    if (!brandtiles) {
        return;
    }

    brandtiles.forEach((brandtile) => {
        const brandclass = [...brandtile.classList].find((el) =>
            el.includes("attrax-vacancy-tile__option-brand--")
        );

        if (!brandclass) {
            return;
        }

        const closestTile = brandtile.closest(".attrax-vacancy-tile");
        if (closestTile) {
            closestTile.classList.add(brandclass);
        }
    });
};

export const setActive = () => {
    const jobtiles = document.querySelectorAll(".attrax-vacancy-tile");

    if (!jobtiles) {
        return;
    }

    jobtiles.forEach((jobtile) => {
        jobtile.classList.add("attrax-vacancy-tile--active");
    });
};

export const wrapJobTitleInH3 = () => {
    const jobTitles = document.querySelectorAll<HTMLElement>(".attrax-vacancy-tile__title");

    if (!jobTitles || jobTitles.length === 0) {
        return;
    }

    jobTitles.forEach((title) => {
        const parentNode = title.parentNode;

        if (!parentNode) {
            return;
        }

        const wrapper = document.createElement("h3");
        wrapper.classList.add("attrax-vacancy-tile__title-wrapper");
        title.removeAttribute("role");
        title.removeAttribute("aria-level");
        parentNode.insertBefore(wrapper, title);
        wrapper.appendChild(title);
    });
};
